module.exports = __webpack_public_path__ + "img/download-layer.0eb4c992.svg";